'use client'
import type { ReactNode } from 'react'

export function Checkbox({ label, checked, onChange }: { label?: ReactNode; checked: boolean; onChange: (next: boolean) => void }) {
  return (
    <label className="inline-flex cursor-pointer items-center gap-2 text-[15px] text-ink-2 select-none">
      <input type="checkbox" checked={checked} onChange={(e) => onChange(e.target.checked)} />
      {label}
    </label>
  )
}
